export default  {
  bindings: {
    day: '=',
    title: '@'
  },
  controller: 'daySaveController',
  template: require('../views/day.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/components/day.save.component.js